export const isProductionEnv = (): boolean => import.meta.env.PROD;
